import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Confetti from 'react-confetti';

export default function CommercialReferralPage() {
    const navigate = useNavigate();
    const [step, setStep] = useState(1); // 1: Input, 2: Success
    const [contacts, setContacts] = useState([
        { name: '', phone: '' },
        { name: '', phone: '' },
        { name: '', phone: '' }
    ]);

    const handleChange = (index, field, value) => {
        const newContacts = [...contacts];
        newContacts[index][field] = value;
        setContacts(newContacts);
    };

    const isComplete = contacts.every(c => c.name.length > 2 && c.phone.length > 8);

    const handleUnlock = () => {
        if (!isComplete) return;
        setStep(2);
        // Ici on pourrait sauvegarder les leads dans Pocketbase
    };

    return (
        <div style={{ height: '100vh', width: '100vw', background: '#0f172a', color: 'white', fontFamily: 'Inter, sans-serif', padding: 40, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

            {step === 2 && <Confetti recycle={false} numberOfPieces={500} />}

            <div style={{ width: '100%', maxWidth: 600, textAlign: 'center' }}>

                {/* Header */}
                <div style={{ marginBottom: 40 }}>
                    <div style={{ fontSize: '4rem', marginBottom: 10 }}>🤝</div>
                    <h1 style={{ fontSize: '2.5rem', fontWeight: 800, margin: 0 }}>Parrainage Express</h1>
                    <p style={{ opacity: 0.6, fontSize: '1.2rem', marginTop: 10 }}>Débloquez votre remise de -10% immédiate.</p>
                </div>

                {step === 1 ? (
                    <div style={{ background: 'rgba(255,255,255,0.05)', padding: 40, borderRadius: 24, border: '1px solid rgba(255,255,255,0.1)' }}>

                        <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
                            {contacts.map((contact, idx) => (
                                <div key={idx} style={{ display: 'flex', gap: 10 }}>
                                    <div style={{ width: 40, height: 50, display: 'grid', placeItems: 'center', fontWeight: 700, opacity: 0.5 }}>#{idx + 1}</div>
                                    <input
                                        type="text" placeholder="Nom de l'ami entrepreneur"
                                        value={contact.name} onChange={e => handleChange(idx, 'name', e.target.value)}
                                        style={{ flex: 1, padding: 15, borderRadius: 12, border: 'none', background: 'rgba(255,255,255,0.1)', color: 'white' }}
                                    />
                                    <input
                                        type="tel" placeholder="06..."
                                        value={contact.phone} onChange={e => handleChange(idx, 'phone', e.target.value)}
                                        style={{ width: 120, padding: 15, borderRadius: 12, border: 'none', background: 'rgba(255,255,255,0.1)', color: 'white' }}
                                    />
                                </div>
                            ))}
                        </div>

                        <div style={{ marginTop: 40, position: 'relative' }}>
                            {/* CADENAS VISUEL */}
                            <div style={{ fontSize: '3rem', position: 'absolute', top: -70, left: '50%', transform: 'translateX(-50%)', opacity: isComplete ? 0 : 1, transition: 'opacity 0.3s' }}>
                                🔒
                            </div>

                            <button
                                onClick={handleUnlock} disabled={!isComplete}
                                style={{
                                    width: '100%', padding: 20, borderRadius: 50, border: 'none',
                                    background: isComplete ? '#22c55e' : '#334155', color: 'white',
                                    fontSize: '1.2rem', fontWeight: 700, cursor: isComplete ? 'pointer' : 'not-allowed',
                                    transition: 'all 0.3s', boxShadow: isComplete ? '0 10px 30px rgba(34, 197, 94, 0.4)' : 'none'
                                }}
                            >
                                {isComplete ? 'DÉVERROUILLER LA REMISE 🔓' : 'Remplissez les 3 contacts...'}
                            </button>
                        </div>

                    </div>
                ) : (
                    <div className="animate-pop">
                        <div style={{
                            background: 'white', color: '#0f172a', padding: 50, borderRadius: 32,
                            display: 'flex', flexDirection: 'column', alignItems: 'center',
                            boxShadow: '0 0 100px rgba(255,255,255,0.2)'
                        }}>
                            <div style={{ fontSize: '5rem', fontWeight: 900, color: '#ef4444' }}>-10%</div>
                            <div style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: 10 }}>APPLIQUÉ SUR LA FACTURE</div>
                            <div style={{ opacity: 0.6 }}>Merci pour votre confiance !</div>

                            <button onClick={() => navigate('/commercial/launchpad')} style={{ marginTop: 40, padding: '15px 40px', background: '#0f172a', color: 'white', borderRadius: 50, border: 'none', fontSize: '1.1rem', fontWeight: 700, cursor: 'pointer' }}>
                                Retour au Launchpad
                            </button>
                        </div>
                    </div>
                )}

                {step === 1 && (
                    <button onClick={() => navigate('/commercial/launchpad')} style={{ marginTop: 30, background: 'transparent', border: 'none', color: 'rgba(255,255,255,0.3)', cursor: 'pointer' }}>Annuler</button>
                )}
            </div>

            <style>{`.animate-pop { animation: popIn 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275); } @keyframes popIn { from { transform: scale(0.5); opacity: 0; } to { transform: scale(1); opacity: 1; } }`}</style>
        </div>
    );
}
